// src/pages/RegisterPage.js
import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const RegisterPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "pharmacist" // default role, no need for user input
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const registerUser = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://installmentzone.com/pharmacy/api/register_user.php",
        formData
      );

      if (res.data.status === "success") {
        toast.success(res.data.message);

        // Save default role for reference
        localStorage.setItem("role", formData.role);

        // Save user info (without auto-login)
        localStorage.setItem("user", JSON.stringify({
          name: formData.name,
          email: formData.email,
          role: formData.role
        }));

        // Redirect to login page
        navigate("/login");

      } else {
        toast.error(res.data.message);
      }

    } catch (error) {
      toast.error("Registration failed");
      console.error(error);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <form
        onSubmit={registerUser}
        className="bg-white p-6 rounded-lg shadow-md w-96 space-y-4"
      >
        <h2 className="text-2xl font-bold text-center">Register</h2>

        <input
          type="text"
          name="name"
          placeholder="Full Name"
          className="input"
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          className="input"
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          className="input"
          onChange={handleChange}
          required
        />

        <button className="btn-primary w-full" type="submit">
          Register
        </button>
      </form>
    </div>
  );
};

export default RegisterPage;